import React from 'react';
import { Edit, NumberInput, ReferenceInput, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { Wrapper } from '../../components';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';

const FuelEdit = (props) => {
    return (
        <Permission permission={PERMISSIONS.ADMIN}>
            <Wrapper>
                <Edit title='Editar combustível filho' {...props}>
                    <SimpleForm redirect={`/parent-fuels`} sx={{ maxWidth: 600 }}>
                        <TextInput disabled label="ID" source="id" sx={{ minWidth: 300 }} />
                        <TextInput source="acronym" label="Sigla" maxlength="3" sx={{ minWidth: 300 }} />
                        <TextInput source="name" label="Nome" sx={{ minWidth: 300 }} />
                        <TextInput source="anpCode" label="Código ANP" sx={{ minWidth: 300 }} />
                        <NumberInput source="fuelType" label='Tipo do combustível (ConectTec)' sx={{ minWidth: 300 }} />
                        <ReferenceInput label="Combustível pai" source="parentFuelId" reference="parent-fuels">
                            <SelectInput optionText="name" sx={{ minWidth: 300 }} />
                        </ReferenceInput>
                    </SimpleForm>
                </Edit>
            </Wrapper>
        </Permission>
    )
};

export default FuelEdit;
